define(function (require) {
	const $ = require('jquery');
	const _ = require('underscore');
	const JSV = require('civicsUtils/JSV');

	return {
		buildUrlParameters: function (options) {
			//console.log('Building URL Based on: ',options);

			var parms = [];
			if (!_.isEmpty(options)) {
				if (!_.isEmpty(options.fieldMappings)) {
					//console.log('buildUrlParameters: options.fieldMappings: ', options.fieldMappings);
					options = this.mapParameters(options);
					// now exclude all extendedFilters, orderby, and filter based on the field Mappings
					options.restrictedProps = _.map(_.select(options.fieldMappings, function (m) {
						return (m.svcName == null || m.svcName.trim().length === 0 ||
						(m.type && m.type.length > 0));
					}), function (a) {
						return a;
					});
				}
				if (!_.isEmpty(options.extendedFilter)) {
					parms.push(this.buildExtendedFilter(options));
				}
				if (!_.isEmpty(options.orderBy)) {
					parms.push(this.buildOrderBy(options.orderBy));
				}
				if (!_.isEmpty(options.select)) {
					parms.push(this.buildSelect(options.select));
				}
				if (!_.isEmpty(options.page)) {
					parms.push(this.buildFilterPage(options.page, 'Page'));
				}
				if (!_.isEmpty(options.filter)) {
					parms.push(this.buildFilterPage(options.filter, 'Filter'));
				}
				if (!_.isEmpty(options.passThroughString)) {
					//allow for the direct passing of a string to the URL parameter string
					//should not have a leading ?
					parms.push(options.passThroughString);
				}
				if (!_.isEmpty(options.passThroughObject)) {
					if ( !this.isExcluded(options,options.passThroughObject))
					parms.push(this.buildPassThroughObject(options.passThroughObject));
				}

				if(!_.isEmpty(options.types)){
					parms.push('FilterString=[{' + this.buildTypeFilter(options.types) + '}]');
				}
			}
			//console.log('built URL Using',options);
			if (parms.length > 0) {
				return '?' + parms.join('&');
			}
			else {
				return '';
			}
		},
		//for re-mapping client side models to their original server side
		//tsables. Used when combining different models into one list, for example
		//SAMPLE MAP CONFIGURATION
		// fieldMappings:[{
		// 	appName:'applicationDateTime',
		// 	svcName:'requestDate'
		// }]
		//where appName is the name the client code expects
		//ans svName is the name the server/DB utilize
		mapParameters: function (options) {
			this.map = options.fieldMappings;
			_.map(options, _.bind(this.mapField, this))
			return options;
		},
		mapField: function (obj, key) {
			var type = typeof obj;
			if (type === 'object' || type === 'array') {
				var found = _.map(obj, _.bind(this.mapField, this));
				for (var i = 0; found && i < found.length; i++) {
					if (found[i]) {
						obj.property = found[i].changeTo;
						if (found[i].changeOperatorTo) {//if operator specified in fieldMappings
							obj.operator = found[i].changeOperatorTo;
							//if operator is 'Equal' remove wildcards that might have been used for the 'Like' operator
							if (obj.operator == 'Equal') {
								obj.value = obj.value.replace(/%25/g, '').replace(/%/g, '');
							}
						}
					}
				}
			} else if (key === 'property') {
				for (var i = 0; i < this.map.length; i++) {
					if (obj === this.map[i].appName && this.map[i].svcName && this.map[i].svcName.trim().length > 0) {
						return {
							found: this.map[i].appName,
							changeTo: this.map[i].svcName,
							changeOperatorTo: this.map[i].operator
						}

					}
				}
			}

		},
		//SAMPLE FILTER CONFIGURATION
		// filter:{
		// 	property:'Amount',
		// 	value:'500'
		// }

		//ALTERNATE FILTER CONFIGURATION
		// filter:[{
		// 	property:'Amount',
		// 	value:'500',
		// 	operator:'LessThan'
		// },
		// {
		// 	property:'Owner',
		// 	value:'Bob Sagat'
		// }]

		//SAMPLE PAGE CONFIGURATION
		//page:{
		// 	max:50,
		// 	start:51
		// }

		//ALTERNATE PAGE CONFIGURATION
		// page:[{
		// 	max:50,
		// 	start:51
		// },
		// {
		// 	property:'InspectionReport',
		// 	Max:3
		// }]

		buildFilterPage: function (filterpage, type) {
			var self = this;
			var retVal = type + '=[';
			//if it's an array, it's a more complex paging request.
			if (Object.prototype.toString.call(filterpage) === '[object Array]') {
				retVal += _.map(filterpage, function (obj, key) {
						return '{' + _.map(obj, function (obj, key) {

								return key + ':' + self.encodeComponent(obj);
							}).join(',') + '}';
					}) + ']';
			} else {
				retVal += '{' + _.map(filterpage, function (obj, key) {
						return key + ':' + self.encodeComponent(obj);
					}).join(',') + '}]';
			}

			return retVal;
		},
		//SAMPLE SELECT CONFIGURATION
		// select:[
		// 	'id',
		// 	'somethingElse',
		// 	'aThirdField'
		// ]
		buildSelect: function (select) {
			return 'Select=[' + _.map(select, function (obj, key) {
					return obj;
				}).join(',') + ']';
		},

		//SAMPLE ORDER BY CONFIGURATION
		// orderBy:[{
		// 	property:'Amount',
		// 	direction:'Desc'
		// }],
		//OrderBy=[{property:Amount,direction:Desc}]
		buildOrderBy: function (order) {
			if (_.isArray(order)) {
				return 'OrderBy=[' + _.map(order, function (obj) {
						return '{' +  _.map(obj, function (obj2, key2) {
								return key2 + ':' + obj2;
							}).join(',') + '}';
					}).join(',') + ']';
			}
			else {
				return 'OrderBy=[{' + _.map(order, function (obj, key) {
						return key + ':' + obj;
					}).join(',') + '}]';
			}
		},
		buildTypeFilter: function(subtype){
			var self = this;
			if (_.isArray(subtype)) {
				return 'Type:[' + _.map(subtype, function (obj) {
						return '{' +  _.map(obj, function (obj2, key2) {
								return key2 + ':' + self.encodeComponent(obj2);
							}).join(',') + '}';
					}).join(',') + ']';
			}
		},
		startValidatedFilters: function (options, filters) {
			if (filters.And || filters.Or) {
				var ret = {};
				if (filters.And)
					ret.And = this.getValidatedFiltersInternal(options, filters.And);
				if (filters.Or)
					ret.Or = this.getValidatedFiltersInternal(options, filters.Or);
				return ret;
			}
		},
		isExcluded: function (options, expression) {
			var excluded = false;
			if (options.dataType && expression.excludedDataType && expression.excludedDataType.length > 0) {

				excluded = (_.filter(expression.excludedDataType, function (t) {
					return t.toUpperCase().trim() === options.dataType.toUpperCase().trim();
				}).length > 0);
			}
			return excluded;
		},
		getValidatedFiltersInternal: function (options, filters) {
			var self = this;
			return _.select(filters, function (expression) {
				var valid = !self.isExcluded(options, expression);

				if (valid) {
					if (expression.And || expression.Or) {
						expression = self.startValidatedFilters(options, expression);
					}
					else if (options.restrictedProps && options.restrictedProps.length > 0) {
						// for each expression, check to see if the expression property == the restricted field or starting with it
						_.each(options.restrictedProps, function (fieldMap) {

							if (fieldMap.svcName == null || fieldMap.svcName.trim().length === 0) {
								if (expression.property.toUpperCase() === fieldMap.appName.toUpperCase() ||
									expression.property.toUpperCase().indexOf(fieldMap.appName.toUpperCase() + '.') == 0) {
									// do not include this in the new list if this filter can't be applied
									//valid = false;
									expression.property = 'id';
									expression.value = 0;
								}
							}
							// if a type is used in the field map , svcName is a required field.
							if (expression.property.toUpperCase() === fieldMap.svcName.toUpperCase()) {
								if (fieldMap.type && fieldMap.type.length > 0) {
									// check for number only as i can think of this is the only type we care for now
									if (fieldMap.type.toLowerCase().trim() == 'number' && isNaN(expression.value)) {
										// do not include this in the new list if this filter can't be applied
										//valid = false;
										expression.property = 'id';
										expression.value = 0;
									}
								}
							}
						});
					}
				}
				return valid;
			});
		},
		//extendedFilter=[{operator: and,nest: [{operator: Or, criteria: [{property: Amount, value: 100}, {property: Amount, value: }]}], criteria: [{property: Ripe, value: true}]
		buildExtendedFilter: function (options) {
			var extendedFilter, retVal;

			if(options.subtypeFilterParam){
				//type or subtype filters will now be removed from extendedFilter property
				var typeFilters = [],
					filters = options.extendedFilter;

				if(filters.And.length > 0){
					filters.And.forEach(function(filter){
						if(filter.property.toLowerCase() == 'instrumentsubtype'){
							//get index
							var index = filters.And.indexOf(filter);
							//add to subtype filter
							//InstrumentSubType filter shouldn't be added to typeFilters when filter['value'] is undefined
							if(filter['value']) {
								typeFilters.push({Code: filter['value'], ID: filter['instrumentTypeID']});
								//then remove from And
								filters.And.splice(index, 1);
							}
						}
					});
				}

				if(filters.Or && filters.Or.length){
					var counter = 0;
					filters.Or.forEach(function(filter){
						if(typeof filter.Or != 'undefined'){
							var filterArray = filter.Or,
								isDelete = false;

							filterArray.forEach(function(x){
								if(x.property.toLowerCase() == 'instrumentsubtype'){
									//InstrumentSubType filter shouldn't be added to typeFilters when x['value'] is undefined
									if(x['value']) {
										typeFilters.push({Code: x['value'], ID: x['instrumentTypeID']});
										isDelete = true;
									}
								}
							});

							if(isDelete){
								var index = filters.Or.indexOf(filter);
								filters.Or.splice(index, 1);
								if(filters.Or.length == 0){
									delete filters.Or;
								}
							}						
						}
						else{
							var isDelete = false;
							if(filter.property.toLowerCase() == 'instrumentsubtype'){
								if(filter['value']) {
									typeFilters.push({Code: filter['value'], ID: filter['instrumentTypeID']});
									isDelete = true;
								}
								counter++;
							}
							
							if(counter == filters.Or.length){
								delete filters.Or;
							}
						}
					});
				}

				//filters variable now contains the filter values aside from subtype and type
				options.extendedFilter = filters;

				if(typeFilters.length > 0){
					//type filters will now be stored to 'types' property
					options.types = typeFilters;
				}
			}
			
			//if(filter.and || filter.or){
			var copyExtendedFilter = (JSV.parse(JSV.stringify(options.extendedFilter)));
			var validatedFilters = this.startValidatedFilters(options, copyExtendedFilter);
			// if(__DEV__) console.log('buildUrlParameters, buildExtendedFilter, validatedFilters: ', validatedFilters);
			extendedFilter = _.map(validatedFilters, _.bind(this.extendedFilterMap, this, options));
			// if(__DEV__) console.log('buildUrlParameters, buildExtendedFilter, extendedFilter: ', extendedFilter);
			if (extendedFilter) {
				retVal = 'ExtendedFilter=' + JSV.stringify(extendedFilter).replace(/\"/g, '').replace(/\&/g, '%26');
			}
			// } else {
			// 	retVal = 'Filter=['+JSON.stringify(filter).replace(/\"/g,'').replace(/\&/g,'%26')+']';
			// }
			//console.log('EXTENDED',retVal);
			//extendedFilter = this.removeTrailingCharacter(extendedFilter,',');
			//if(__DEV__) console.log('buildUrlParameters, buildExtendedFilter, retVal: ', retVal);
			return retVal;
		},

		//SAMPLE EXTENDED FILTER CONFIGURATION
		// {
		// 	"and": [{
		// 		"and": [{
		// 			"type": "date",
		// 			"property": "PaymentDate",
		// 			"value": "2015-07-04",
		// 			"operator": "GreaterThanOrEqual"
		// 		}, {
		// 			"type": "date",
		// 			"property": "PaymentDate",
		// 			"value": "2015-08-04",
		// 			"operator": "LessThanOrEqual"
		// 		}]
		// 	}, {
		// 		"and": [{
		// 			"type": "number",
		// 			"property": "Amount",
		// 			"value": "1",
		// 			"operator": "GreaterThanOrEqual"
		// 		}, {
		// 			"type": "number",
		// 			"property": "Amount",
		// 			"value": "20",
		// 			"operator": "LessThanOrEqual"
		// 		}]
		// 	}]
		// }

		extendedFilterMap: function (options, obj, key, depth) {

			if (typeof depth == 'number')
				depth++;
			else
				depth = 1;

			//if (__DEV__) console.log('*******************************: ', depth);
			// if(__DEV__) console.log('buildUrlParameters, extendedFilterMap, depth, key,obj,JSON.stringify(obj): ', depth, key,obj,JSON.stringify(obj));
			var retObj;
			if (Object.prototype.toString.call(obj) === '[object Array]') {
				// if(__DEV__) console.log('buildUrlParameters, extendedFilterMap, is [object Array]: ', depth);
				retObj = {
					operator: key
				};
				var nest = false;
				for (var i = 0; i < obj.length; i++) {
					if (obj[i].And || obj[i].Or) {
						nest = true;
						break;
					}
				}
				if (nest) {
					// if(__DEV__) console.log('buildUrlParameters, extendedFilterMap, is nest: ', depth);
					var newArray = _.map(obj, _.bind(this.extendedFilterMap, this, options, _, _, depth));
					var anotherArray = [];
					var criteriaArray = [];
					//console.log('newArray',newArray);
					for (var j = 0; j < newArray.length; j++) {
						//console.log('New Array[j]: ',newArray[j]);
						//console.log('has operator?: ',newArray[j].operator);

						if (!newArray[j][0] || !newArray[j][0].operator) {
							//console.log('adding Criteria');
							criteriaArray.push(newArray[j]);
						} else {
							anotherArray.push(newArray[j][0]);
						}
					}
					if (criteriaArray.length > 0) {
						anotherArray.push({
							criteria: criteriaArray
						});
					}
					retObj.nest = anotherArray;
					// if(__DEV__) console.log('buildUrlParameters, extendedFilterMap, is nest, depth, retObj.nest: ', depth, retObj.nest);
				} else {
					retObj.criteria = _.map(obj, _.bind(this.extendedFilterMap, this, options, _, _, depth));
					// if(__DEV__) console.log('buildUrlParameters, extendedFilterMap, not nest, depth, retObj.criteria: ', depth, retObj.criteria);
				}
			} else if (typeof obj === 'object') {
				if (obj.And || obj.Or) {
					retObj = _.map(obj, _.bind(this.extendedFilterMap, this, options, _, _, depth))
				} else {
					if (obj.value) {
						obj.value = this.encodeComponent(obj.value);
					}
					retObj = obj;
				}
				// if(__DEV__) console.log('buildUrlParameters, extendedFilterMap, is object, depth, retObj: ', depth, retObj);
			} else {

			}
			//if(__DEV__) console.log('buildUrlParameters, extendedFilterMap, at end, depth, retObj: ', depth, retObj);
			return retObj;
		},
		buildPassThroughObject: function (pta) {
			var ptaStrings = [];
			//console.log(pta);
			for (var property in pta) {
				if (pta.hasOwnProperty(property) && property != ('excludedDataType')) {
					ptaStrings.push(property + '=' + pta[property]);
				}
			}
			return ptaStrings.join('&');
		},
		//ecode the url component
		encodeComponent: function (val) {
			if ( typeof val == "string") {
				val = JSV.escapeString(val);
				return encodeURIComponent(val);
			}
			else {
				return val;
			}

		}

	}

});
